import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import {
    EncounterRx,
    EncounterRxStatus
} from '../../models/encounter-rx';

const checkAppointmentHasRxSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<EncounterRx>) => memoize((
        appointmentId: Undefinable<number>
    ) => Object
        .keys(byId)
        .filter(x => appointmentId && byId[x]!.appointmentId === appointmentId)
        .length > 0
    )
);

const getEncounterRxIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<EncounterRx>) => memoize((
        appointmentId: Undefinable<number>
    ) => memoize((
        status: EncounterRxStatus
    ) => Object
        .keys(byId)
        .filter(x => appointmentId && byId[x]!.appointmentId === appointmentId && byId[x]!.status === status)
        .map(x => +x)
        .sort((a, b) => a - b)
    ))
);

export const selectors = {
    checkAppointmentHasRx: (
        state: State,
        appointmentId: Undefinable<number>
    ): boolean => checkAppointmentHasRxSelector(state)(appointmentId),
    getEncounterRx: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<EncounterRx> => state.byId[id || ''],
    getEncounterRxIds: (
        state: State,
        appointmentId: Undefinable<number>,
        status: EncounterRxStatus
    ): number[] => getEncounterRxIdsSelector(state)(appointmentId)(status),
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
